<template>
    <div class="clientForm">
        <div class="row">
            <div class="col-sm-12 d-flex flex-column mb-3">
                <label>Name:</label>
                
                <input :disabled="disabled" type="text" class="fs-bigger bg-lighter bold" v-model="customer.name" @input="inputChanged">
            </div>

            <div class="col-sm-6 d-flex flex-column mt-1 mb-3">
                <label>Country:</label>

                <country-picker :topCodes="topCountries" openDirection="bottom" :selectedCountryValue="selectedCountry" :disabled="false" :allowEmpty="false" @input="updateCountry($event, 'country')" :customClass="'mb-2'" :error="!selectedCountry" ></country-picker>
            </div>

            <div class="col-sm-6 d-flex flex-column mt-1 mb-3">
                <label>Phone:</label>
               
                <div class="row">
                    <div class="col-4 pr-2">
                        <input :disabled="disabled" type="text" class="fs-bigger bg-lighter w-100" placeholder="+351" v-model="customer.dial" @input="onDialInput">
                    </div>

                    <div class="col-8 pl-0">
                        <input :disabled="disabled" type="text" class="fs-bigger bg-lighter w-100" v-model="customer.phone">
                    </div>
                </div>
            </div>

            <div class="col-sm-6 d-flex flex-column mt-1 mb-3">
                <label>Hotel:</label>
               
                <input :disabled="disabled" type="text" class="fs-bigger bg-lighter" v-model="customer.accomodation" @input="inputChanged">
            </div>

            <div class="col-sm-6 d-flex flex-column mt-1 mb-3">
                <label>Room:</label>
                
                <input :disabled="disabled" type="text" class="fs-bigger bg-lighter" v-model="customer.room" @input="inputChanged">
            </div>

            <div class="col-sm-12 d-flex flex-column mt-1 mb-3">
                <label :class="{'color-6': !$v.customer.email.email}">Email:</label>
                
                <input :disabled="disabled" type="text" class="fs-bigger bg-lighter" v-model="customer.email" @input="inputChanged">
                
                <span v-if="!$v.customer.email.email" class="color-6 fs-smaller">
                    <span v-if="!$v.customer.email.email">Invalid email</span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, cenas } from 'vuex'
    import { email } from 'vuelidate/lib/validators'
    import { eventHub } from "@/main"

    import extendedVSelect from '@/extends/vue-select'
    import debounce from 'lodash/debounce'
    import CountryPicker from '@/tools/CountryPicker'

    export default {
        data() {
            return {
                defaultCountry: null,
                selectedCountry: null,
                onDialInput: null,
                topCountries: ['PT', 'GB', 'US', 'ES', 'FR']
            }
        },
        props: {
            customer:{
                type: Object
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        validations: {
            customer: {
                email: {
                    email
                }
            }
        },
        mounted() {
            this.setDefaults();
        },
        created() {
            // 1000ms debounce to not interrupt typing
            this.onDialInput = debounce(() => {
                this.updateCountry('dial');
            }, 1000);
        },
        computed: {
            ...mapGetters([
                'getCountries'
            ]),
        },
        methods: {
            setDefaults() {
                this.defaultCountry = this.getCountries.find(c => c.default);
                this.selectedCountry = this.getCountries.find(c => c.id === this.customer.country) || this.defaultCountry;
            },
            updateCountry(event = null, type) {
                this.selectedCountry = event;

                if (type === 'country') {
                    this.applyCountryInfo(this.selectedCountry);

                    return;
                }

                // Dial/Code input
                const numeric = this.customer.dial;
                const country = this.findCountryByDial(this.customer.dial);

                if (country) {
                    this.selectedCountry = country;
                    this.applyCountryInfo(country);
                } else {
                    this.resetCountryInfo();
                }
            },
            findCountryByDial(dialInput) {
                let dial = (dialInput || '').replace(/\D/g, '');
                if (dial.startsWith('00')) dial = dial.slice(2);
                if (!dial) return null;

                // Filter countries
                const topCountries = this.getCountries.filter(c => this.topCountries.includes(c.code2));
                const allCountries = this.getCountries.filter(c => !this.topCountries.includes(c.code2));
                const finalCountries = [...topCountries, ...allCountries]

                // Finded country
                const country = finalCountries.find(n => n.dial === dial);
                
                if (country && country.length !== 0) {
                    return country;
                } else {
                    return null;
                }
            },
            applyCountryInfo(country) {
                this.customer.country = country.id;
                this.customer.dial = country.code;
                this.customer.countryName = country.name;
            },
            resetCountryInfo() {
                this.customer.country = null;
                this.customer.dial = null;
                this.customer.countryName = '';
                this.selectedCountry = null;
            },
            inputChanged(val) {
                this.$emit('update', this.customer);
            }
        },
        components: {
            vSelect: extendedVSelect,
            CountryPicker
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../assets/scss/_utility.scss';

    label {
        width: 80px;
        min-width: 80px;
    }

    input {
        width: 100%;

        &.clickable {
            border-color: $lightest;
            @extend .darker;
        }
    }

    textarea {
        width: 100%;
        padding: 0.2rem 0.45rem;
    }
</style>



// WEBPACK FOOTER //
// ClientForm.vue?1314a868